const InputField = ({
  value,
  setValue,
}: {
  value: string;
  setValue: Function;
}) => {
  return (
    <input
      className="codeinput"
      value={value}
      onChange={(e) => setValue(e.target.value)}
    ></input>
  );
};

export default InputField;
